import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mainCard", "bodyTable", "footerTable", "dateStatus", "saveBtn", "deleteBtn", "saveCard", "titleCard", "cpf", 
    "dependent", "memberDropdown", "memberInput", "memberList", "memberDropdownBtn"]

  connect() {
    this.controllerName = `operations--products--tax-returns--settings--members`
    this.itemsOnPage = 20
    this.pageNumber = 0
    this.numberPages = []
    this.doMembersListHtml()
    this.doViewHtml()
  }

  newMember() {
    this.actionMode = "new"
    this.doFormHtml()
  }

  editMember(ev) {
    this.application.members.forEach(element => {
      if (element.id == ev.target.closest(".itemRow").dataset.id) {
        this.member = element
      }
    });

    this.actionMode = "edit"
    this.doFormHtml()
  }

  savePatient() {
    if (this.actionMode == "new") {
      var data = { 
                   member: { cpf: this.getControllerByIdentifier("app--helpers--numbers").fromCpfToNumber(this.cpfTarget.value),
                             name: this.dependentTarget.value, sex: this.memberInputTarget.dataset.sex, kind: "dependent",
                             tax_return_id: this.application.tax_return.id, date_id: this.application.current_date.id },
                   current_user: { current_user_id: currentUser.id }
                 }
    } else if (this.actionMode == "edit") {
      var data = { 
                   member: { id: this.member.id, name: this.dependentTarget.value, sex: this.memberInputTarget.dataset.sex },
                   current_user: { current_user_id: currentUser.id } 
                 }
    }
    this.requestSave(data)
  }

  requestSave(data) {
    const token = $('meta[name=csrf-token]').attr('content');
    if (this.actionMode == "edit") {
      var url = "/operations/products/tax_returns/members/update"
      var method = "PUT"
    } else if (this.actionMode == "new") {
      var url = "/operations/products/tax_returns/members/create"
      var method = "POST"
    }

    const init = { method: method, credentials: "same-origin", headers: { "X-CSRF-Token": token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        if (response.save) {
          this.stopRefreshing()
          this.cancelSave()
          var member = response.data.cln
          if (this.actionMode == "edit") {
            if (member.active) {
              this.application.members.forEach((element, i) => {
                if (element.id == member.id) {
                  this.application.members.splice(this.application.members.indexOf(element), 1, member)
                }
              })
            } else {
              this.application.members.forEach((element, i) => {
                if (element.id == member.id) {
                  this.application.members.splice(this.application.members.indexOf(element), 1)
                }
              })
            }
          } else {
            this.application.members[this.application.members.length] = member
          }
          this.getControllerByIdentifier("operations--products--tax-returns--settings--members").doDataTable()
        } else {
          this.saveBtnTarget.disabled = false
          if (this.hasDeleteBtnTarget) {
            this.deleteBtnTarget.disabled = true
          }
        }
        this.getControllerByIdentifier("app--helpers--snackbar").doSnackbar(response.type, response.message, 2000)
      })
      .catch(error => {
        controller.getControllerByIdentifier("app--helpers--console").console(error)
        this.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", this.getControllerByIdentifier("app--helpers--messages").generalError(), 3000)
      })
  }

  doFormHtml() {
    this.stopRefreshing()

    if (this.application.medreturn_members.can_create) {
      var saveBtnHtml = `<button type="button" class="btn btn-primary btn-sm" data-action="click->${this.controllerName}#savePatient" data-${this.controllerName}-target="saveBtn">Salvar</button>`
    } else {
      var saveBtnHtml = ``
    }
    // if (this.application.medreturn_members.can_delete && this.actionMode == "edit") {
    //   var deleteBtnHtml = `<button disabled type="button" class="btn btn-danger btn-sm" data-action="click->${this.controllerName}#deletePatient" data-${this.controllerName}-target="deleteBtn">Apagar</button>`
    // } else {
    //   var deleteBtnHtml = ``
    // }

    var deleteBtnHtml = ``


    var html = `<div class="card" style="width:100%;display:relative;" data-${this.controllerName}-target="saveCard" data-action="resize@window->${this.controllerName}#layout">
                  <div class="card-header d-flex align-items-center card-header-table-list">
                    <h6 class="card-title display-4 card-title-table-list" data-${this.controllerName}-target="titleCard"></h6>
                  </div>
                  <div class="card-body py-0" style="overflow:auto;">
                    <div class="row my-2">
                      <div class="col-4 pl-0 pr-1">
                        <div class="form-group">
                          <div class="floating-label floating-label-sm">
                            <label for="dependentForm">CPF</label>
                            <input aria-describedby="dependentFormHelp" class="form-control form-valid-control" id="dependentForm" data-${this.controllerName}-target="cpf" data-action="blur->${this.controllerName}#cpfMask keypress->${this.controllerName}#cpfMask" placeholder="CPF do Dependente" type="text" required>
                          </div>
                        </div>
                      </div>
                      <div class="col-8 pl-2 pr-1">
                        <div class="form-group">
                          <div class="floating-label floating-label-sm">
                            <label for="nameForm">Nome do Dependente</label>
                            <input aria-describedby="nameFormHelp" class="form-control form-valid-control" id="nameForm" data-${this.controllerName}-target="dependent" placeholder="Nome do Dependente" type="text" required>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row my-2">
                      <div class="col-6 pl-0 pr-1">
                        <div class="form-group">
                          <div class="floating-label floating-label-sm">
                            <label>Sexo Paciente</label>
                            <div class="dropdown dropdown-selector dropdown-valid-selector" data-${this.controllerName}-target="memberDropdown">
                              <button class="dropdown-toggle form-control d-flex" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="height:32px;" data-${this.controllerName}-target="memberDropdownBtn"><span class="mr-auto w-100 selected-item" id="selected" data-${this.controllerName}-target="memberInput"></span></button>
                              <div class="dropdown-menu dropdown-menu-selector w-100 box-shadow-selector">
                                <input class="form-control form-control-selector dropdown-search-input" type="text" placeholder="Buscar ...">
                                <ul class="ul-select" data-${this.controllerName}-target="memberList">
                                  <li data-sex="male" class="li-selector dark">Masculino</li>
                                  <li data-sex="female" class="li-selector dark">Feminino</li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card-footer border-top text-right py-1">
                    <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" data-action="click->${this.controllerName}#cancelSave">Fechar</button>
                    ${deleteBtnHtml}
                    ${saveBtnHtml}
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier("operations--products--tax-returns--settings--dashboard").showMemberTarget.innerHTML = html)
    }).then(() => {
      controller.getControllerByIdentifier("app--helpers--elements").tooltip()
      controller.saveCardTarget.style.height = ($(window).height() * 0.35) + "px"
      if (controller.actionMode == "new") {
        controller.titleCardTarget.innerText = `Novo Dependente`
      } else if (controller.actionMode == "edit") {
        controller.titleCardTarget.innerText = `Editando Dependente`
        controller.cpfTarget.value = controller.member.account_cpf_pretty
        controller.cpfTarget.disabled = true
        controller.dependentTarget.value = controller.member.account_name
        controller.dependentTarget.disabled = true
        controller.memberDropdownTarget.value = controller.member.account_sex
        controller.memberInputTarget.innerText = controller.member.account_sex_pretty
        controller.memberInputTarget.dataset.sex = controller.member.account_sex
        controller.memberDropdownBtnTarget.classList.add("disabled")
      }
      // controller.refreshSaveBtn()
      controller.getControllerByIdentifier("app--helpers--forms").floatingLabel()

    })
  }

  doViewHtml() {
    var html = `<div class="card" style="width:100%;display:relative;" data-${this.controllerName}-target="viewMemberCard">
                  <div class="card-header d-flex align-items-center card-header-table-list">
                    <h6 class="card-title display-4 f-065" style="padding:1rem;font-size:110%;margin-bottom:0px;" data-${this.controllerName}-target="viewTitle">Nenhum Membro Selecionado</h6>
                  </div>
                </div>`

    this.getControllerByIdentifier("operations--products--tax-returns--settings--dashboard").showMemberTarget.innerHTML = html
  }

  doMembersListHtml() {
    if (this.application.medreturn_members.can_create) {
      var createBtn = `<button aria-expanded="false" aria-haspopup="true" class="btn btn-outline my-0" data-toggle="tooltip" data-placement="top" data-original-title="Adicionar Membro" data-action="click->${this.controllerName}#newMember" type="button"><i class="material-icons">add</i></button>`
    } else {
      var createBtn = ``
    }


    var html = `<div class="card" style="width:100%;display:relative;" data-${this.controllerName}-target="mainCard" data-action="resize@window->${this.controllerName}#layout">
                  <div class="card-header d-flex align-items-center card-header-table-list f-065">
                    <h6 class="card-title display-4 card-title-table-list">Titular e Dependentes ${this.application.current_date.year}</h6>
                    <div class="card-actions ml-auto py-0">
                      ${createBtn}
                    </div>
                  </div>
                  <div class="card-body py-0" style="overflow:auto;">
                    <div class="row">
                      <div class="col p-0">
                        <div class="table-responsive">
                          <table class="table table-sm table-hover table-search" style="font-size:80%;" id="searchMembersTable">
                            <thead>
                              <tr>
                                <th style="font-size:80%;" scope="col" class="p-1 table-70 align-middle">Nome</th>
                                <th style="font-size:80%;" scope="col" class="p-1 table-25 align-middle">Tipo</th>
                                <th class="table-3"></th>
                                <th class="table-3"></th>
                              </tr>
                            </thead>
                            <tbody data-${this.controllerName}-target="bodyTable">
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card-footer py-0" data-${this.controllerName}-target="footerTable">
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier("operations--products--tax-returns--settings--dashboard").listMembersTarget.innerHTML = html)
    }).then(() => {
      controller.getControllerByIdentifier("app--helpers--elements").tooltip()
      controller.mainCardTarget.style.height = ($(window).height() * 0.30) + "px"
      controller.bodyTableTarget.insertAdjacentHTML("beforeend", controller.getControllerByIdentifier("app--helpers--table").doTablePreloader(3, 2))
      controller.doDataTable()
    })
  }

  doDataTable() {
    var current_members = []
    this.application.members.forEach(element => {
      if (element.date_id == this.application.current_date.id) {
        current_members[current_members.length] = element
      }
    });
    var members = this.getControllerByIdentifier("app--helpers--data").sortByKeyAsc(current_members, "account_name")

    if (members.length == 0) {
      var pagination = { itemsOnPage: 0, fromItem: 0, toItem: 0, totalItems: 0 }
      this.listData()
      // this.doFooterTable(pagination)
    } else {
      var itemsOnPage = this.itemsOnPage
      var pageNumber = this.pageNumber
      var numberPages = this.numberPages
      var pages = []
      var itemLoop = Math.ceil(members.length / itemsOnPage)
      var x = 0
      var i = 1
      for (i; i < itemLoop + 1; i++) {
        var internPage = []
        for (x; x < itemsOnPage * i; x++) {
          if (members[x] !== undefined) {
            internPage[internPage.length] = members[x]
          }
        }
        pages[pages.length] = internPage
        numberPages[numberPages.length] = i - 1
      }

      var fromItem = itemsOnPage * pageNumber + 1
      var toItem = Math.min(itemsOnPage * (pageNumber + 1), (itemsOnPage * pageNumber) + pages[pageNumber].length)
      var pagination = { itemsOnPage: itemsOnPage, fromItem: fromItem, toItem: toItem, totalItems: members.length }
      this.listData(pages[pageNumber])
      // this.doFooterTable(pagination)
    }
  }

  listData(data) {
    this.bodyTableTarget.innerHTML = ""
    if (data == undefined || data == [] || data.length == 0) {
      var noData = `</tr>
                      <td colspan="7" class="p-3 align-middle text-center" style="font-size:100%;">
                        <span class="fa-stack fa-1x">
                          <i class="fas fa-list fa-stack-1x"></i>
                        </span>
                        <span class="f-075 align-middle">Não há Membros na Competência</span>
                      </td>
                    </tr>`

      this.bodyTableTarget.innerHTML = noData
    } else {
      data.forEach(element => {
        this.bodyTableTarget.insertAdjacentHTML("beforeend", this.memberTablePartial(element, data.length))
      });
    }
    this.getControllerByIdentifier("app--helpers--elements").tooltip()
  }

  memberTablePartial(element, length) {
    
    if (this.application.medreturn_members.can_copy) {
      var copyPath = `<button type="button" class="btn btn-sm btn-table copy p-0" data-toggle="tooltip" data-placement="right" title data-original-title="Copiar"><i class="material-icons md-sm md-light">file_copy</i></button>`
    } else {
      var copyPath = ``
    }

    if (this.application.medreturn_members.can_update) {
      var editBtn = `<button data-action="click->${this.controllerName}#editMember" type="button" class="btn btn-sm btn-table p-0" data-toggle="tooltip" data-placement="top" title data-original-title="Editar"><span class="material-icons md-sm md-dark">edit</span></button>`
    } else {
      var editBtn = ``
    }

    if (this.application.medreturn_members.can_delete) {
      var deleteBtn = `<button data-action="click->${this.controllerName}#deleteMember" type="button" class="btn btn-sm btn-table p-0" data-toggle="tooltip" data-placement="top" title data-original-title="Apagar"><span class="material-icons md-sm md-dark">delete</span></button>`
    } else {
      var deleteBtn = ``
    }

    if (length == 1) {
      var tableRow = `<tr class="itemRow" data-id="${element.id}" style="height:50px;">`
    } else {
      var tableRow = `<tr class="itemRow" data-id="${element.id}">`
    }

    var rowHtml = `${tableRow}
                    <th style="font-size:80%;" scope="col" class="p-1 align-middle">${element.account_name}</th>
                    <th style="font-size:80%;" scope="col" class="p-1 align-middle">${element.kind_pretty}</th>
                    <th class="table-3 align-middle">${editBtn}</th>
                    <th class="table-3 align-middle">${deleteBtn}</th>
                  </tr>`

    return rowHtml
  }

  itemsLength(ev) {
    this.itemsOnPage = ev.target.dataset.items
    this.pageNumber = 0
    this.numberPages = []
    this.doDataTable()
  }

  previousTablePage(ev) {
    if (this.numberPages.includes(this.pageNumber - 1)) {
      this.pageNumber -= 1
      this.doDataTable()
    }
  }

  nextTablePage(ev) {
    if (this.numberPages.includes(this.pageNumber + 1)) {
      this.pageNumber += 1
      this.doDataTable()
    }
  }

  doFooterTable(pagination) {
    var footerHtml = `<div class="card-actions align-items-center justify-content-end py-0">
                        <span class="align-self-center mb-1 mx-1 text-muted">Itens por Página:</span>
                        <div class="dropdown">
                          <button aria-expanded="false" aria-haspopup="true" class="btn btn-outline dropdown-toggle" data-toggle="dropdown" type="button">${pagination.itemsOnPage}</button>
                          <div class="dropdown-menu dropdown-menu-right menu">
                            <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="20">20</span>
                            <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="50">50</span>
                            <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="100">100</span>
                          </div>
                        </div>
                        <span class="align-self-center mb-1 mr-2 text-muted">${pagination.fromItem}-${pagination.toItem} de ${pagination.totalItems}</span>
                        <a class="btn btn-outline py-0" data-action="click->${this.controllerName}#previousTablePage"><i class="material-icons">chevron_left</i></a>
                        <a class="btn btn-outline py-0" data-action="click->${this.controllerName}#nextTablePage"><i class="material-icons">chevron_right</i></a>
                      </div>`

    this.footerTableTarget.innerHTML = footerHtml
  }

  cpfMask(ev) {
    this.getControllerByIdentifier("app--helpers--numbers").changeNumberToCpf(ev)
  }

  cancelSave() {
    this.stopRefreshing()
    this.doViewHtml()
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  layout() {
    var targets = ["mainCard"]
    var identifier = ""
    // this.getControllerByIdentifier("app--helpers--layout").resizeMainCard(targets, identifier)
  }

  refreshSaveBtn() {
    var controller = this
    this.refreshTimer = setInterval(function () {
      var len = 0
      controller.validGroupTargets.forEach(element => {
        if (this.fromStringToBoolean(element.dataset.valid) == false) {
          len += 1
        }
      });
      if (len == 0) {
        controller.saveBtnTarget.disabled = false
      } else {
        controller.saveBtnTarget.disabled = true
      }
    }, 200);
  }

  stopRefreshing() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
